import type { RouteObject } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const FTOSearchHub = lazyRoute(
  () => import('pages/FTO/FTOSearchHub/FTOSearchHub'),
  m => m.FTOSearchHub,
);
const FTOSearchResultsWrapper = lazyRoute(
  () => import('pages/FTO/FTOSearchResults/FTOSearchResultsWrapper'),
  m => m.FTOSearchResultsWrapper,
);
const FTOSearchSteps = lazyRoute(
  () => import('pages/FTO/FTOSearchSteps/FTOSearchSteps'),
  m => m.FTOSearchSteps,
);

export const ftoRoutes: RouteObject[] = [
  { path: PATHNAMES.fto, lazy: FTOSearchHub },
  { path: PATHNAMES.ftoNewSearch, lazy: FTOSearchSteps },
  { path: PATHNAMES.ftoSearch, lazy: FTOSearchResultsWrapper },
];
